import $http from './http'
import config from './config'

export default {
    name: 'tourpolicy',
    getUrl(url) {
        return config.getUrl(this.name, url);
    },
}


// WEBPACK FOOTER //
// ./src/apis/tourPolicyApi.js